// Stale-deploy recovery. After a new build deploys, the hashed chunk filenames change.
// A browser still running the old index.html will fail to dynamically import a route's
// chunk ("Failed to fetch dynamically imported module" / "importing a module script
// failed"). Instead of showing an error, reload ONCE to pick up the fresh index.html.
// A sessionStorage time-guard prevents an infinite reload loop if the chunk is genuinely
// broken (not just stale).

const KEY = "frayze-chunk-reload-at";
const GUARD_MS = 10000;

export function isChunkLoadError(message = ""): boolean {
  return /importing a module script failed|failed to fetch dynamically imported module|error loading dynamically imported module|dynamically imported module/i.test(
    message
  );
}

/** Reloads the page at most once per GUARD_MS window. Returns true if it reloaded. */
export function reloadOnceForChunkError(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const last = Number(window.sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last > GUARD_MS) {
      window.sessionStorage.setItem(KEY, String(Date.now()));
      window.location.reload();
      return true;
    }
  } catch {
    // sessionStorage unavailable (private mode etc.): fall through, show the boundary.
  }
  return false;
}
